import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

const AttendeeLoginFormData = async (payload: any, eventId: Number) => {
    try {
        const response = await axios.post(`${HOSTAPI}/events/${eventId}/attendee/login`, payload, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return {
            status: response.status,
            data: response.data
        };
    } catch (error: any) {

        return {
            status: error.response.status,
            data: error.response.data
        };
    }
};

export default AttendeeLoginFormData;
